import { userService } from '../../services/UserService';
import { orderService } from '../../services/OrderService';

const state = {
    settings: {},
    settingsLoaded: false,

    orderTypeSettings: {},
    orderTypeSettingsLoaded: false,
};

const getters = {


    appSettings: (state) => state.settings.AppSettings,
    userSettings: (state) => state.settings.UserSettings,

    settingsLoaded: (state) => state.settingsLoaded,

    // orderTypeSettings
    orderTypeSettings: (state) => state.orderTypeSettings,
    orderTypeSettingsLoaded: (state) => state.orderTypeSettingsLoaded,

    typeSettings: (state) => {
        return function (typeId) {

            if (typeId != 'undefined' && typeId != 0 ) {
                //console.log('vuex.general.typeSettings: typeId=' + typeId);

                //console.log('vuex.general.state.orderTypeSettings[typeId]=' + typeId);

                return state.orderTypeSettings[typeId];
            }
            else {
                return null;
            }

        }
    },
};

const actions = {

    getSettings: ({ commit, rootGetters }) => {
        //console.log('vuex.general.getSettings');
        return new Promise((resolve, reject) => {

            if (state.settingsLoaded) {
                //console.log('vuex.general.settingsLoaded resolve');
                resolve(state.orderTypeSettings);
            }
            else {
                return userService.getSettings()
                    .then(result => {
                        const allSettigs = result.data;
                        
                        commit('storeSettings', allSettigs);
                        commit('setSettingsLoaded', true);

                        resolve(allSettigs);
                    });
            }
        });
    },


    getOrderTypeSettings: ({ commit, rootGetters }) => {
        
        //console.log('vuex.general.orderTypeSettings');
        return new Promise((resolve, reject) => {

            if (state.orderTypeSettingsLoaded) {
                //console.log('vuex.general.orderTypeSettingsLoaded == true');
                resolve(state.orderTypeSettings);
            }
            else {
                orderService.getOrderTypeSettings()
                    .then(result => {
                        const allOrderTypes = result.data;

                        commit('storeOrderTypeSettings', allOrderTypes);
                        commit('setOrderTypeSettingsLoaded', true);

                        resolve(allOrderTypes);
                    });
            }
        });
    },

};

const mutations = {

    // Application and user settings
    setSettingsLoaded: (state, loaded) => {
        state.settingsLoaded = loaded;
    },

    storeSettings: (state, settings) => {
        state.settings = settings;
    },

    // order types
    storeOrderTypeSettings: (state, orderTypes) => {
        ////console.log('vuex.GENERAL.storeOrderTypeSettings= ' + JSON.stringify(orderTypes));
        state.orderTypeSettings = orderTypes;
    },
    setOrderTypeSettingsLoaded: (state, loaded) => {

        //console.log('vuex.general.setOrderTypeSettingsLoaded= ' + loaded);
        state.orderTypeSettingsLoaded = loaded;
    },


};

export default {
    state,
    getters,
    actions,
    mutations,
};
